export enum SectionStateStatus {
  Loading = 'Loading',
  LoadingTransparent = 'LoadingTransparent',
  HideLoading = 'HideLoading',
  Ready = 'Ready',
  Disconnected = 'Disconnected',
  Error = 'Error',
  Empty = 'Empty',
  SearchResultEmpty = 'SearchResultEmpty',
  ComingSoon = 'ComingSoon',
}

export enum NotificationStatus {
  Show = 'Show',
  Hide = 'Hide',
}

export enum DrawingTypeEnum {
  Drawing = 'Drawing',
  NonDrawing = 'NonDrawing',
}

export enum ScreenType {
  phone = 'phone',
  tablet = 'tablet',
  desktop = 'desktop',
}

export enum DrawerPosition {
  Start = 'start',
  End = 'end',
}

export enum DrawerMode {
  Side = 'side',
  Over = 'over',
  Push = 'push',
}

export enum DrawerType {
  MobileMenu = 'mobileMenu',
  Notifications = 'notifications',
  ProfileMenu = 'profileMenu',
  Filters = 'filters',
  ColumnOptions = 'columnOptions',
}

export enum TableRowClicked {
  ROW_CLICKED = 'clicked',
}
export enum CheckboxStatus {
  ALL_SELECTED = 'all-selected',
  INDETERMINATE = 'indeterminate',
}

export enum SpinnerSize {
  NORMAL = 'normal',
  SMALL = 'small',
  ULTRA_SMALL = 'ultraSmall',
}

export enum ProfileMenuAction {
  LOGOUT = 'logout',
  CHANGE_LANGUAGE = 'change-language',
  USER_PROFILE = 'user-profile',
}

export enum ScreenSizes {
  TABLET = 900,
  MOBILE = 480,
}

export enum TabAnimation {
  NEXT = 'next',
  PREVIOUS = 'previous',
  NONE = 'none',
}

export enum DashboardTabsActions {
  VISUALIZED_REPORTS = 'visualized-reports',
  BALANCE_REPORT = 'balance-report',
  PEAK_REPORT = 'peak-report',
  CONTACT_US_MESSAGES = 'contact-us-messages',
}

export enum ChartType {
  LINE = 'line',
  BAR = 'bar',
  RADAR = 'radar',
  PIE = 'pie',
  POLAR_AREA = 'polarArea',
  DOUGHNUT = 'doughnut',
  BUBBLE = 'bubble',
  SCATTER = 'scatter',
  CHOROPLETH = 'choropleth',
}

export enum ViewStyle {
  TABLE = 'table',
  BAR_CHART = 'bar-chart',
  DOUGHNUT_CHART = 'doughnut-chart',
}

export enum ComparisonStatus {
  EQUAL = 'equal',
  BIGGER = 'bigger',
  SMALLER = 'smaller',
}

export enum PeakReportViewType {
  MONTH = 'month',
  DAY = 'day',
  HOUR = 'hour',
}

export enum InputTypes {
  TEXT = 'text',
  NUMBER = 'number',
  PASSWORD = 'password',
  EMAIL = 'email',
  PHONE = 'tel',
  TIME = 'time',
}

export enum ConfirmationModalActions {
  CONFIRM = 'confirm',
  CANCEL = 'cancel',
}

export enum NestedPermissionsKeys {
  HOME_PAGE = 'home',
  REPORTS = 'reports',
  SESSIONS = 'sessions',
  SETTINGS = 'settings',
  UPLOAD = 'upload',
  USERS_MANAGEMENT = 'users-management',
}

export enum ButtonPositions {
  START = 'flex-start',
  CENTER = 'center',
  END = 'flex-end',
}

export enum MediaPlayerFlag {
  PLAY = 'play',
  PAUSE = 'pause',
  REPLAY = 'replay',
}

export enum SessionRating {
  BAD = 'bad',
  GOOD = 'good',
  VERY_GOOD = 'very_good',
  EXCELLENT = 'excellent',
}

export enum Days {
  SUNDAY = 'sunday',
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
}

export enum PlanReadingType {
  TAJWEED = 'tajweed',
  HADR = 'hadr',
}

export enum Languages {
  ARABIC = 'ar',
  ENGLISH = 'en',
  FRENCH = 'fr',
  GERMAN = 'de',
  SPANISH = 'es',
  RUSSIAN = 'ru',
  CHINESE = 'zh',
}

export enum LevelOfExperience {
  BEGINNER = 'beginner',
  MEDIUM = 'intermediate',
  ADVANCED = 'advanced',
}

export enum EducationalLevel {
  // PRIMARY = 'primary',
  // MEDIUM = 'medium',
  // SECONDARY = 'secondary',
  // UNIVERSITY = 'university',
  BEGINNER = 'beginner',
  MEDIUM = 'intermediate',
  ADVANCED = 'advanced',
}

export enum StudentLearingPlan {
  SURAH = 'surah',
  PARTS = 'parts',
  PAGES = 'pages',
}

export enum StudentPlanOrder {
  NORMAL = 'normal',
  REVERSED = 'reversed',
}

export enum ReservationStatus {
  TEMPORARY_RESERVED = 'temporary-reserved',
  PENDING_PAYMENT = 'pending-payment',
  UNRESERVED = 'unreserved',
  RESERVED = 'reserved',
}

export enum CssThemes {
  SUPER_ADMIN = 'super_admin',
  MODDAKIR = 'moddakir',
  MODDAKIR_KIDS = 'moddakir_kids',
  BREDA = 'breda',
  WL2 = 'wl_2',
  WL3 = 'wl_3',
  WL5 = 'wl_5',
  WL6 = 'wl_6',
}

export enum StudentPathPreferenceType {
  INITIATION = 'initiation', //talqeen
  READ_AND_EJAZA = 'readAndEjaza', //eqra3&ejazah
  RECITE = 'recite', //tasmee3
  RECITATION = 'recitationCorrection', //telawah
  RECITE_AND_RECITATION = 'recite-and-recitationCorrection', //tasmee3 and telawah
  FOUNDATION = 'foundation',
  AFFIRMATION = 'affirmation',
  REVISION = 'revision',
  MEMORIZE = 'memorize',
  SCHOOL_CURRICULUM = 'school-curriculum',
  UNKNOWN = 'Unknown',
  REVIEW = 'Review',
  INSTALLING = 'Installing',
}

export enum NotificationStatus {
  Seen = 'seen',
  Not_Seen = 'not-seen',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum FatihaRequestAction {
  APPROVE = 'approve',
  REJECT = 'reject',
}

export enum Wa3iSessionTypes {
  BOTH = 'both',
  SHORT = 'short',
  LONG = 'long',
}

export enum ConsultantBalanceStatus {
  Current = 'Current',
  Recived = 'Recived',
}
